import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Index',
        meta: {
            title: "深圳市公标知识产权鉴定评估中心",
        },
        component: () =>import ( /* webpackChunkName: "home" */ '../../views/index/home/index.vue')
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
        },
        component: () =>
            import(/* webpackChunkName: "login" */ "../../views/index/login/index.vue"),
    },
    {
        path: "/reg",
        name: "reg",
        meta: {
            title: "注册",
        },
        component: () =>
            import(/* webpackChunkName: "reg" */ "../../views/index/reg/index.vue"),
    },
    {
      path: "/forget",
      name: "forget",
      meta: {
          title: "忘记密码",
      },
      component: () =>
          import(/* webpackChunkName: "forget" */ "../../views/index/forget/index.vue"),
    },

]


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: "history",
    base: '/',
    routes,
});
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    console.log(targetPath);
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

export default router;